import React, { FC, useContext } from 'react';

import { useAdvertisementMutations } from 'hooks';
import { LocalizationContext } from 'localization';

import { IPartnerItemProps } from './interfaces';
import { PartnerEdgeIcon } from './PartnerEdgeIcon';
import s from './PartnerItem.module.scss';

export const PartnerItem: FC<IPartnerItemProps> = ({ data }) => {
  const { t } = useContext(LocalizationContext);

  const { handledIncrementPartnerCounter } = useAdvertisementMutations(t);

  const IMAGE_PROXY_BASE = process.env.REACT_APP_IMAGE_PROXY_BASE;

  return (
    <a
      href={data?.target_url}
      onClick={() => {
        if (data?.id) return handledIncrementPartnerCounter(data?.id);
      }}
      target="_blank"
      className={s.container}
      rel="noreferrer"
    >
      <div className={s.edge}>
        <PartnerEdgeIcon />
      </div>
      <div className={s.header}>
        {data?.image === '' ? (
          <img
            className={s.image}
            src={`/images/Advertisement/emptyAdvertisementImageBlue.png`}
            alt="placeholder_image"
          />
        ) : (
          <div
            className={s.blur}
            style={{
              backgroundImage: `url(${IMAGE_PROXY_BASE}/rs:fit:248:248/g:sm/plain/${data?.image})`,
            }}
          >
            <img
              className={s.image}
              src={`${IMAGE_PROXY_BASE}/rs:fit:248:248/g:sm/plain/${data?.image}`}
              srcSet={`
                ${IMAGE_PROXY_BASE}/rs:fit:248:248/g:sm/plain/${data?.image} 1x,
                ${IMAGE_PROXY_BASE}/rs:fit:496:496/g:sm/plain/${data?.image} 2x,
                ${IMAGE_PROXY_BASE}/rs:fit:744:744/g:sm/plain/${data?.image} 3x,
      `}
              alt="#"
            />
          </div>
        )}

        <div className={s.label_block}>
          <span className={s.label}>{t('advertising')}</span>

          {/*{data?.metadata && (*/}
          {/*  <span className={s.tooltip}>{JSON.parse(data?.metadata)}</span>*/}
          {/*)}*/}
        </div>
      </div>
      <p className={s.text}>{data?.title}</p>
      <button className={s.button}>{t('go.action')}</button>
    </a>
  );
};
